import ComingSoon from "../../components/coming-soon";
import PropTypes from "prop-types";

export default function NonTargetedView({ assetsUrl }) {
  return (
    <div>
      <ComingSoon assetsUrl={assetsUrl} />
    </div>
  );
}

NonTargetedView.propTypes = {
  assetsUrl: PropTypes.string,
};
